import { Typography, styled } from '@mui/material';

const StyledDrawerMenuLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500
}));

export default StyledDrawerMenuLabel;
